export enum NotificationTypesEnum {
    Update = 0,
    Security = 1,
    OneTimeCode = 2,
}
